import gsap from "gsap";
import { select } from '../utility/dom';
var Event;
(function (Event) {
    Event["EXPAND"] = "Accordion.Expand";
    Event["FOLD"] = "Accordion.Fold";
})(Event || (Event = {}));
;
export default class Accordion {
    constructor(el, params = {}) {
        const _params = Object.assign({}, {
            itemSelector: '.accordion-item',
            itemHandlerSelector: '.ani--handler',
            itemBodySelector: '.ani--body',
            expandedClassname: '-expanded',
        }, params);
        this._el = el;
        this._items = select(_params.itemSelector, this._el).all();
        this._items.forEach(item => {
            new AccordionItem(item, _params);
        });
    }
}
class AccordionItem extends EventTarget {
    constructor(el, params) {
        super();
        this._expanded = false;
        const _this = this;
        this._params = params;
        this._el = el;
        this._clickHandler = select(params.itemHandlerSelector, el).first;
        this._body = select(params.itemBodySelector, el).first;
        this._expanded = this._el.classList.contains(params.expandedClassname);
        this._expanded ? this.expand() : this.fold();
        window.addEventListener('resize', () => _this._getBodyHeight());
        this._getBodyHeight();
        this._clickHandler && this._clickHandler.addEventListener('click', (event) => {
            event.preventDefault();
            _this.toggle();
        });
    }
    expand() {
        const height = this._bodyHeight;
        const element = this._body;
        this._expanded = true;
        this._el.classList.add(this._params.expandedClassname);
        this._el.setAttribute('aria-expanded', 'true');
        gsap.to(element, { height, opacity: 1, duration: .5, ease: 'power3.out' });
        this._dispatchEvent(Event.EXPAND);
    }
    fold() {
        const element = this._body;
        this._expanded = false;
        this._el.classList.remove(this._params.expandedClassname);
        this._el.setAttribute('aria-expanded', 'false');
        gsap.to(element, { height: 0, opacity: 0, duration: .5, ease: 'power3.out' });
        this._dispatchEvent(Event.FOLD);
    }
    toggle() {
        this._expanded ? this.fold() : this.expand();
    }
    _getBodyHeight() {
        if (!this._body) {
            return;
        }
        const node = this._body.cloneNode(true);
        node.style.visibility = 'hidden';
        node.style.pointerEvents = 'none';
        node.style.height = 'auto';
        this._body.parentNode && this._body.parentNode.appendChild(node);
        this._bodyHeight = node.offsetHeight;
        node.parentNode && node.parentNode.removeChild(node);
    }
    _dispatchEvent(eventType) {
        const element = this._el;
        const event = new CustomEvent(eventType, {
            detail: {
                element,
                instance: this,
            },
        });
        this.dispatchEvent(event);
    }
}
